import i18n from 'i18next';
import { Button } from 'antd';
import React from 'react';
import ProfReportLT from '../../../../../assets/pdf/prof-report_lt-LT.pdf';
import ProfReportEN from '../../../../../assets/pdf/prof-report_en-US.pdf';
import { useTranslation } from 'react-i18next';

const ExampleBtn = () => {
  const { t } = useTranslation();

  const getReportExampleByLang = lang => {
    switch (lang) {
      case 'lt-LT':
        return ProfReportLT;
      case 'en-US':
        return ProfReportEN;
      default:
        return ProfReportLT;
    }
  };

  return (
    <a href="#" onClick={() => window.open(`${getReportExampleByLang(i18n.language)}`, '_blank')}>
      <Button className="btn-success-bordered">{t('companyResult.buyReport.reportTable.example')}</Button>
    </a>
  );
};

export default ExampleBtn;
